import { ChevronDown } from "lucide-react";

const fmt = (digits) => [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 9)].filter(Boolean).join(" ");

export const isUaeMobile = (digits) => /^5\d{8}$/.test(digits);

export function UaePhoneInput({ value, onChange, testid }) {
  const handle = (e) => {
    let d = e.target.value.replace(/\D/g, "");
    if (d.startsWith("971")) d = d.slice(3);
    if (d.startsWith("0")) d = d.slice(1);
    onChange(d.slice(0, 9));
  };
  return (
    <>
    <div className="flex h-12 rounded-xl border border-input bg-white overflow-hidden focus-within:ring-2 focus-within:ring-[#1A5C3A]/30" dir="ltr" data-testid={testid}>
      <div className="flex items-center gap-1.5 px-3 border-e border-slate-200 bg-slate-50 select-none" data-testid={`${testid}-country`}>
        <img src="https://flagcdn.com/w40/ae.png" alt="UAE" className="w-6 h-4 rounded-sm object-cover" />
        <span className="text-sm font-semibold text-slate-700">+971</span>
        <ChevronDown className="w-3.5 h-3.5 text-slate-400" />
      </div>
      <input type="tel" inputMode="numeric" required value={fmt(value)} onChange={handle} placeholder="5X XXX XXXX"
        className="flex-1 px-3 text-sm outline-none bg-transparent tracking-wide" data-testid={`${testid}-number`} />
    </div>
    {value && !value.startsWith("5") && <p className="text-xs text-red-600 mt-1" data-testid={`${testid}-hint`}>يجب أن يبدأ الرقم بـ 5 · Must start with 5</p>}
    </>
  );
}
